import React from "react";
import { saveAs } from 'file-saver';

//Downloading the file : for any files
//Specify for files like images that cause app to open the image instead of downloading it

let initPath = "https://paksereshthome.com"

export default function fileDownloader(fileName, fileLink) {
    fetch(initPath + fileLink)
    .then(response => response.blob())
    .then(blob => {
        saveAs(blob, fileName);
    })
    .catch(error => {
        console.error('Error:', error);
    });
}
